import Icon from "./IconBase.js";
const FilterIconWhite = (props) => {
  return (
    <Icon width="24" height="24" viewBox="0 0 24 24" {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 18 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.56409 1.5H10.4359C11.0238 1.5 11.5 1.99053 11.5 2.59613V3.36188C11.5 3.65566 11.3852 3.93778 11.1813 4.14354L7.92883 7.43351C7.87272 7.49078 7.79653 7.5226 7.71776 7.52207L4.99447 7.51359C4.91158 7.51359 4.83282 7.47806 4.77619 7.41601L1.78726 4.12869C1.60245 3.92559 1.5 3.65725 1.5 3.37885V2.59666C1.5 1.99106 1.97619 1.5 2.56409 1.5ZM5.14005 8.41207L7.56734 8.4195C7.71869 8.42003 7.84121 8.54677 7.84121 8.70214V10.0677C7.84121 10.2236 7.75266 10.3646 7.6147 10.4299L5.41135 11.4645C5.35987 11.4883 5.3053 11.5 5.25073 11.5C5.17815 11.5 5.10556 11.4788 5.04224 11.4369C4.93156 11.3637 4.86463 11.2375 4.86463 11.1023V8.69472C4.86463 8.53828 4.98819 8.41154 5.14005 8.41207Z"
          fill="white"
        />
      </svg>
    </Icon>
  );
};
export default FilterIconWhite;
